import React from 'react';
import ProductSlider from '../ProductSlider';

const Career = () => {
          return (
                    <div className='bg-blue-100'>
                              <div className=' pt-28'>
<h1 class="text-5xl text-sky-900 text-center font-serif p-2">
When we say we’re the best to work with,  </h1>
<h1 class="text-5xl  text-sky-900 text-center font-serif p-2">
 The only thing missing is you.</h1>
<h1 class="text-5xl  text-sky-900 text-center font-serif p-2">
we mean it.</h1>

<div className=' text-center '>
          <button className='btn btn-blue mt-5  bg-blue-900 text-white text-center rounded-full'>Life at Instrument</button>
</div>
</div>
<ProductSlider></ProductSlider>
<div className=' '>
    <h1 className='text-center text-4xl font-semi-bold  items-center text-sky-900 text-start m-48'>We're always looking for more great people to join our team. If you don't see a match in our open roles, we'd love to hear from you via our general application.
</h1>
    {/* <h1 className='text-center text-3xl font-semi-bold items-center  text-sky-900'> If you don't see a match in our open roles,

</h1>
    <h1 className='text-center text-3xl font-semi-bold text-sky-900 items-center'> we'd love to hear from you via our general application.

</h1> */}
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-24 gap-28'>
    <div>
<h1 className='text-4xl font-extra-bold text-sky-900'>Design</h1>
    </div> 
    <div>
        <p className='text-2xl text-sky-900 font-semi-bold'>Visuals and interactions know no boundaries at Instrument. We start anywhere, with anything, to deliver world-class products and experiences that seamlessly blend form and function.</p>
    </div>
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-28'>
    <div>
<h1 className='text-4xl font-extra-bold text-sky-900'>Strategy</h1>
    </div> 
    <div>
        <p className='text-2xl text-sky-900 font-semi-bold'>Big ideas and meaningful insights fuel our fire. From User Experience (UX) to Brand Strategy, we collaborate closely with both clients and our Design and Technology teammates to tackle complex problems at the heart of human experiences.</p>
    </div>
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-28'>
    <div>
<h1 className='text-4xl font-extra-bold text-sky-900'>Technology</h1>
    </div> 
    <div>
        <p className='text-2xl text-sky-900 font-semi-bold'>We use technology to build best-in-class digital experiences. Join our engineering team to collaborate on all parts of the development life cycle and bring engaging and functional products to life.</p>
    </div>
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-28'>
    <div>
<h1 className='text-4xl font-extra-bold text-sky-900'>Production</h1>
    </div> 
    <div>
        <p className='text-2xl text-sky-900 font-semi-bold'>We show up every day with strategic minds, creative eyes, technical wisdom, and full hearts. Producers here are valued for being the spark in our work and teams; we don’t run around putting out fires—we help start them.</p>
    </div>
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-28'>
    <div>
<h1 className='text-4xl font-extra-bold text-sky-900'>Operations</h1>
    </div> 
    <div>
        <p className='text-2xl text-sky-900 font-semi-bold'>From recruiting to human development to finance and IT — we do whatever it takes to keep our teams running smoothly.</p>
    </div>
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-28'>
    <div>
<h1 className='text-4xl font-extra-bold text-sky-900'>General</h1>
    </div> 
    <div>
        <p className='text-2xl text-sky-900 font-semi-bold'>
We’re always looking for great people to join our team. Please contact us using the application below to get the conversation started..</p>
    </div>
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='bg-blue-100  m-36'>
<h1 class="text-6xl font-bold text-black text-center text-sky-900">Build . Grow . Serve</h1>
<p className='text-center text-4xl mt-5  text-sky-900 font-serif'>To support grassroots change in our communities, Instrument matches donations made by employees to non-profit organizations.</p>
<div className='mx-auto text-center justify-items-center justify-center align-middle'>
          <button className='btn bg-blue-900 mt-6 bg-white text-white mx-auto text-center justify-items-center justify-center align-middle rounded-full'>Get in Touch</button>
</div>
</div>
<div class="flex flex-col w-full">

  <div class="divider"></div> 
 
</div>
<div className='bg-blue-100 m-48'>
<h1 class="text-2xl font-bold text-black text-center text-sky-900">Instrument is committed to equity</h1>
<p className='text-center text-2xl p-5 text-sky-900 font-serif'>We are committed to providing an inclusive and welcoming environment for all members of our community. Instrument does not and shall not discriminate on the basis of race, color, religion, gender, gender expression, age, national origin, disability, marital status, sexual orientation or military status. Our pay bands ensure equity and serve as an essential benchmark for measuring the velocity of performance against monetary growth.</p>
<div className='mx-auto text-center justify-items-center justify-center align-middle'>
          <button className='btn m-5 bg-blue-900 text-white mx-auto text-center justify-items-center justify-center align-middle rounded-full'>Compensation philosophy</button>
</div>
</div>
                    </div>
          );
};

export default Career;